import Component1035 from '../../imports/그룹1035-194-66';

/**
 * 로그인 페이지 로고 컴포넌트
 * - 녹색 hero 배경 + OLULO 로고만 렌더링
 * - 환영 메시지(`Welcome!` 헤딩)는 부모 컴포넌트(LoginPage)의 흰색 카드 영역에서 렌더링됨
 *   → 중복 렌더링 회피 (이전: hero + 흰 카드 양쪽에 동일 헤딩 노출)
 */
export function LoginLogo() {
  return (
    <div className="bg-primary pt-[clamp(2rem,8vw,4rem)] pb-[clamp(3rem,12vw,6rem)] px-[min(5vw,1.25rem)]">
      <div className="flex justify-center">
        {/* OLULO Logo - Figma Design */}
        <div
          className="w-[clamp(120px,35vw,165px)] h-auto"
          style={{ '--fill-0': '#F6F6F6' } as React.CSSProperties}
        >
          <Component1035 />
        </div>
      </div>
    </div>
  );
}
